import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28fa9f7a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=28fa9f7a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28fa9f7a')) {
      api.createRecord('28fa9f7a', component.options)
    } else {
      api.reload('28fa9f7a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=28fa9f7a", function () {
      api.rerender('28fa9f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Painel/index.vue"
export default component.exports